import React, { Component } from 'react';
import { Form, message, Row } from 'antd';
import { queryMaterialBorrowList, querySaveMaterialReturn } from '@api/administrative/material';
import '../../expenses.less';
import { connect } from 'react-redux';
import FlowSearch from '@comm/FlowSearch';

import { setBackInfo } from '@store/modules/back_info';
import TableExpenses from './TableExpenses';

class PageManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataSource: {
        list: [],
        pagination: {},
        loading: false,
      },
    };
  }

  componentWillMount() {
    this.type = '0';
  }

  componentDidMount() {
    this.searchCondition = {};
    const { backInfo } = this.props;
    if (backInfo.path === this.props.route.path) {
      if (backInfo.start && backInfo.limit) {
        this.current = backInfo.start;
        this.pagination = {
          limit: backInfo.limit,
          start: backInfo.start,
        };
      }
      backInfo.condition && (this.searchCondition.condition = backInfo.condition);
      backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
      backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
      backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
      backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
    }
    this.loadData();
  }

  componentWillUnmount() {
    const params = {
      path: this.props.route.path,
      ...this.searchCondition,
      ...this.pagination,
    };
    this.props.dispatch(setBackInfo(params));
  }

  setTableData = res => {
    this.setState({
      dataSource: {
        list: res.data,
        pagination: {
          total: res.totalSize,
          pageSize: 15,
          current: this.current,
        },
      },
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.loadData();
  };

  handleSearch = params => {
    this.searchCondition = {
      ...params,
    };
    this.current = 1;
    this.pagination = {
      start: 1,
    };
    this.loadData();
  };

  getMaterialBorrowList = params => {
    this.setState({ loading: true });
    queryMaterialBorrowList(params).then(res => {
      if (res.statusCode === 200) {
        this.setTableData(res);
      }
      this.setState({ loading: false });
    });
  };

  loadData = () => {
    const params = {
      ...this.searchCondition,
      ...this.pagination,
    };
    this.getMaterialBorrowList(params);
  };

  handleReturnCancel = () => {};

  handleSaveReturn = data => {
    const params = data;
    querySaveMaterialReturn(params).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message, 2.5);
        this.handleReturnCancel();
      } else {
        message.error(res.message, 2.5);
        this.handleReturnCancel();
      }
    });
  };

  render() {
    const { loading, dataSource } = this.state;
    const parentProps = {
      loading,
      dataSource,
      onChange: this.handleTableChange,
    };
    return (
      <div>
        <Row>
          <FlowSearch onSearch={this.handleSearch} {...this.searchCondition} />
        </Row>
        <TableExpenses {...parentProps} />
      </div>
    );
  }
}

export default connect(state => ({
  backInfo: state.back_info,
}))(Form.create()(PageManage));



// WEBPACK FOOTER //
// ./src/components/administrative/material/borrow/PageWatch.js